import { getToken } from 'helper/common';
import agent from '../../../service/agent';
import {
    CHANGE_PASSWORD_ERROR,
    CHANGE_PASSWORD_ERROR_CLEAR,
    CHANGE_PASSWORD_PENDING,
    CHANGE_PASSWORD_SUCCESS,
    CLOSE_CHANGE_PASSWORD_MODAL,
    OPEN_CHANGE_PASSWORD_MODAL,
} from "./constants";
import { openSnackbar } from 'store/slices/snackbar';
import { trimmedValues } from 'helper/trim';

export const openChangePasswordModal = () => ({
    type: OPEN_CHANGE_PASSWORD_MODAL
})
export const closeChangePasswordModal = () => ({
    type: CLOSE_CHANGE_PASSWORD_MODAL
})
export const changePasswordPending = () => ({
    type: CHANGE_PASSWORD_PENDING
})
export const changePasswordError = (errorMessage) => ({
    type: CHANGE_PASSWORD_ERROR,
    payload: { errorMessage }
})
export const changePasswordErrorClear = () => ({
    type: CHANGE_PASSWORD_ERROR_CLEAR
})
export const changePasswordSuccess = () => ({
    type: CHANGE_PASSWORD_SUCCESS,
})

export const changePassword = (formData) => (dispatch) => {
    const dataToSend = trimmedValues({ ...formData })
    dispatch(changePasswordPending());
    return getToken(dispatch).then((accessToken) => {
        return agent.authentication.changePassword(accessToken, dataToSend)
            .then((response) => {
                dispatch(changePasswordSuccess(response));
                dispatch(closeChangePasswordModal());
                dispatch(openSnackbar({
                    open: true,
                    message: 'Password successfully changed.',
                    variant: 'alert',
                    close: false
                }))
            })
            .catch((err) => {
                console.log(err)
                if (err && err.status === 400) {
                    dispatch(changePasswordError(err.response && err.response.text))
                }
                else {
                    dispatch(changePasswordError(":( Network Error"));
                }
                dispatch(openSnackbar({
                    open: true,
                    message: 'Something went wrong. Try again.',
                    variant: 'alert',
                    close: false
                }))
            })
    })

}